"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "colony-grid-container" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_colony_space = (0, vue_1.resolveComponent)("colony-space");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)([0, 1, 2, 3, 4, 5, 6], (idx) => {
            return (0, vue_1.createVNode)(_component_colony_space, {
                key: idx,
                idx: idx,
                metadata: _ctx.metadata,
                player: _ctx.colony.colonies[idx],
                marker: _ctx.colony.isActive && _ctx.colony.trackPosition === idx
            }, null, 8, ["idx", "metadata", "player", "marker"]);
        }), 64))
    ]));
}
